<script setup lang="ts">
const time = defineModel<string>({ required: true })

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  { disabled: false }
)
</script>

<template>
  <TimeSelect v-model="time" :disabled="disabled" />
</template>
